<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const statusCode = computed(() => {
  return props.error?.statusCode ?? HttpStatusCode.NotFound
})
</script>

<template>
  <LazyMaintenance v-if="statusCode === HttpStatusCode.ServiceUnavailable" />
  <LazyErrorBoundary v-else :error="error" :status-code="statusCode" />
</template>
